import React from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function WhatsIncluded() {
  const books = [{
    title: 'Book 1 – Getting Started',
    desc: 'Learn how to prepare your dog, your location, and your light before you even tap the screen.'
  }, {
    title: 'Book 2 – Phone Camera Basics',
    desc: 'Use your smartphone camera more effectively for sharper, cleaner, better-looking dog photos.'
  }, {
    title: 'Book 3 – Poses and Angles',
    desc: 'Discover simple ways to make your dog look more expressive, flattering, and photogenic.'
  }, {
    title: 'Book 4 – Personality and Emotion',
    desc: 'Capture the moments that actually feel like your dog.'
  }, {
    title: 'Book 5 – Movement and Action',
    desc: 'Take better running, jumping, playful, and dynamic dog photos with your phone.'
  }, {
    title: 'Book 6 – Beautiful Final Results',
    desc: "Create stylish, shareable, frame-worthy dog photos you'll want to post, save, and print."
  }];
  return <section className="bg-warm-mid py-16 md:py-24 px-4" data-id="element-241">
      <div className="max-w-4xl mx-auto" data-id="element-242">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-center text-black mb-4 leading-tight" data-id="element-243">
          📘 What's included in The{' '}
          <span className="italic text-soft-gold" data-id="element-244">Pawfect</span> Shot MegaPack?
        </h2>

        <p className="font-sans text-xl text-center text-orange font-bold mb-12 uppercase tracking-wide" data-id="element-245">
          6 complete books
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-246">
          {books.map((book, index) => <div key={index} className="bg-cream p-6 rounded-xl border border-soft-gold/20 shadow-sm hover:shadow-md transition-shadow" data-id="element-247">
              <h3 className="font-sans font-bold text-xl text-black mb-3 flex items-start" data-id="element-248">
                <span className="text-blue-500 mr-2" data-id="element-249">🔹</span>
                {book.title}
              </h3>
              <p className="font-sans text-gray-700 leading-relaxed pl-7" data-id="element-250">
                {book.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-gray-50 p-8 md:p-10 rounded-2xl border border-gray-200 mb-12" data-id="element-251">
          <h3 className="font-serif text-2xl font-bold text-black mb-6 text-center" data-id="element-252">
            Also included:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-253">
            {['simple step-by-step lessons', 'checklists', 'action steps', 'practical examples', 'beginner-friendly explanations', 'a complete phone-friendly system'].map((item, index) => <div key={index} className="flex items-center" data-id="element-254">
                <span className="text-green-500 mr-3 text-xl" data-id="element-255">✓</span>
                <span className="font-sans text-lg text-gray-800 font-medium" data-id="element-256">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        <p className="font-serif text-2xl text-center text-black font-bold italic mb-10" data-id="element-257">
          Everything is organized to help you improve faster and stop relying on
          random luck.
        </p>

        <div className="text-center" data-id="element-258">
          <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-xl md:text-2xl py-5 px-10 rounded-full shadow-lg transition-all duration-300 transform hover:-translate-y-1 uppercase text-center" data-id="element-259">
            👉 ACCESS THE MEGAPACK NOW
          </button>
        </div>
      </div>
    </section>;
}